import React from "react";
import { Mail, Phone, HelpCircle } from "lucide-react";

export default function Help() {
  return (
    <div className="mw-fade-up space-y-5">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight text-white">YARDIM</h1>
        <p className="text-sm text-slate-400">DESTEK VE İLETİŞİM</p>
      </div>
      <div className="max-w-xl rounded-xl border border-slate-800 bg-slate-900 p-6">
        <div className="mb-4 flex items-center gap-2 text-blue-300"><HelpCircle className="h-5 w-5" /> <span className="font-head text-lg font-bold">DESTEK HATTI</span></div>
        <div className="space-y-3">
          <a href="mailto:osnenufu@gmail.com" className="flex items-center gap-3 rounded-lg border border-slate-800 bg-slate-800/40 p-4 hover:border-blue-600">
            <Mail className="h-5 w-5 text-blue-400" />
            <div><div className="text-xs text-slate-500">EMAIL</div><div className="text-slate-200">osnenufu@gmail.com</div></div>
          </a>
          <a href="tel:+905400344228" className="flex items-center gap-3 rounded-lg border border-slate-800 bg-slate-800/40 p-4 hover:border-blue-600">
            <Phone className="h-5 w-5 text-emerald-400" />
            <div><div className="text-xs text-slate-500">TELEFON</div><div className="text-slate-200">540 034 42 28</div></div>
          </a>
        </div>
      </div>
    </div>
  );
}
